<section class="form-container">
  <h2>Generate Reports</h2>
  <form [formGroup]="reportForm" (ngSubmit)="generateReport()">
    <div class="form-row">
      <div class="form-field" id="scroll-export-name">
        <label for="export_name">
          Export Name - (please use numbers, letters and - only)</label
        >
        <input
          formControlName="exportName"
          type="text"
          id="export_name"
          class="export-name"
        />
        <span *ngIf="missingExportName" class="error-text"
          >Please include a name for the report</span
        >
      </div>
    </div>
    <div class="form-row name-textbox">
      <div class="form-field select-form-field">
        <label for="date-filter">Select report type:</label>
        <select formControlName="dateFilter" id="date-filter" class="bg-grey">
          <option *ngFor="let filter of dateFilters" [attr.value]="filter.id">
            {{ filter.label }}
          </option>
        </select>
      </div>
    </div>
    <div *ngIf="universityUpdateReport" class="form-row">
      <div class="form-field select-form-field">
        <label for="date-filter">Select Premium Partner (From/To):</label>
        <select
          formControlName="premiumPartner"
          id="premium-partner"
          class="bg-grey"
        >
          <option value="">All</option>
          <option
            *ngFor="let partner of premiumPartners"
            [attr.value]="partner.uuid"
          >
            {{ partner.name }}
          </option>
        </select>
      </div>
    </div>
    <label>Select columns to display:</label>
    <div class="select-all-btn-container">
      <span class="select-all-btn" (click)="selectOrDeselect(true)"
        >Select All</span
      >
      <span>|</span>
      <span class="select-all-btn" (click)="selectOrDeselect(false)"
        >Deselect All</span
      >
    </div>
    <div class="checkbox-container">
      <ng-container *ngIf="universityUpdateReport; else standardCheckboxes">
        <label
          *ngFor="
            let params of universityReportColumnValues.controls;
            let i = index
          "
          formArrayName="universityReportColumns"
          [for]="'uni-' + universityReportColumnsArray[i].id"
          class="toggle report-param-label"
        >
          <span class="report-param-label-text">{{
            universityReportColumnsArray[i].label
          }}</span>
          <span class="switch">
            <input
              [formControlName]="i"
              [id]="'uni-' + universityReportColumnsArray[i].id"
              type="checkbox"
              class="toggle"
              value="1"
            />
            <span class="slider"></span>
          </span>
        </label>
      </ng-container>
      <ng-template #standardCheckboxes>
        <label
          *ngFor="let params of reportColumnValues.controls; let i = index"
          formArrayName="reportColumns"
          [for]="reportColumnsArray[i].id"
          class="toggle report-param-label"
        >
          <span class="report-param-label-text">{{
            reportColumnsArray[i].label
          }}</span>
          <span class="switch">
            <input
              [formControlName]="i"
              [id]="reportColumnsArray[i].id"
              type="checkbox"
              class="toggle"
              value="1"
            />
            <span class="slider"></span>
          </span>
        </label>
      </ng-template>
    </div>
    <div
      *ngIf="reportForm.get('dateFilter')?.value"
      class="date-input-container form-row"
    >
      <div class="date-input">
        <app-date-picker
          formControlName="fromDate"
          [placeholder]="'From Date'"
          [dateError]="fromDateError"
        ></app-date-picker>
        <span *ngIf="fromDateError" class="error-text"
          >The date field is required.</span
        >
        <span *ngIf="!fromDateError && datesInvalid" class="error-text"
          >From date cannot be before To date</span
        >
      </div>
      <div class="date-input">
        <app-date-picker
          formControlName="toDate"
          [placeholder]="'To Date'"
        ></app-date-picker>
        <span *ngIf="toDateError" class="error-text"
          >The date field is required.</span
        >
      </div>
    </div>
    <div class="form-errors report-success" *ngIf="reportSuccess">
      <p class="form-error">A report has been generated</p>
    </div>
    <div class="form-errors" *ngIf="reportFailed">
      <p class="form-error">
        {{ reportErrorMessage }}
      </p>
    </div>
    <button
      class="button"
      type="submit"
      [disabled]="loading"
      [class.button-loading]="loading"
    >
      <span>Generate Report</span>
    </button>
  </form>
</section>
